import { render } from "./InitialPorfolioTable.vue?vue&type=template&id=367b14ef&scoped=true"
import script from "./InitialPorfolioTable.vue?vue&type=script&lang=js"
export * from "./InitialPorfolioTable.vue?vue&type=script&lang=js"

import "./InitialPorfolioTable.vue?vue&type=style&index=0&id=367b14ef&lang=scss&scoped=true"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367b14ef"]])

export default __exports__